import { AddressModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const HistoricalAddressEntityData = createEntityDataContext<AddressModel>();
